module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('div', [(_vm.user.id == _vm.tournament.organizer_id) ? _c('router-link', {
    staticClass: "btn-secondary",
    attrs: {
      "to": ("/tournament/" + (_vm.$route.params.id) + "/rename")
    }
  }, [_vm._v("\n                Umbenennen\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.tournament.name))])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("Organisator")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": '/profile/' + _vm.tournament.organizer_id
    }
  }, [_c('dp', {
    attrs: {
      "who": _vm.tournament.organizer
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.tournament.organizer.firstname) + " " + _vm._s(_vm.tournament.organizer.lastname))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)], 1), _vm._v(" "), (_vm.tournament.status == 'waiting') ? _c('section', [_c('h2', [_vm._v("Einladungen")]), _vm._v(" "), _vm._l((_vm.tournament.invitations), function(inv) {
    return _c('router-link', {
      key: inv.id,
      staticClass: "item",
      attrs: {
        "to": '/profile/' + inv.user_id
      }
    }, [_c('dp', {
      attrs: {
        "who": inv.invitee
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(inv.invitee.firstname) + " " + _vm._s(inv.invitee.lastname))]), _vm._v(" "), (inv.accepted) ? _c('small', [_vm._v("Akzeptiert")]) : _c('small', [_vm._v("Ausstehend")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tournament.status == 'completed') ? [_c('section', [_c('h2', [_vm._v("Gewinner")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": '/profile/' + _vm.winner.id
    }
  }, [_c('dp', {
    attrs: {
      "who": _vm.winner
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.winner)))])], 1)], 1), _vm._v(" "), _c('section', [_c('h2', [_vm._v("Zweitplatzierter")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": '/profile/' + _vm.second.id
    }
  }, [_c('dp', {
    attrs: {
      "who": _vm.second
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.second)))])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.tournament.status != 'waiting') ? [_c('section', [_c('header', [_c('h2', [_vm._v("Gruppe")]), _vm._v(" "), _c('div', {
    staticClass: "choice"
  }, _vm._l((_vm.groups), function(group, groupNo) {
    return _c('a', {
      class: {
        'btn-secondary': _vm.groupFilter == groupNo
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.groupFilter = groupNo
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("numToLetter")(groupNo)) + "\n                    ")])
  }))]), _vm._v(" "), _c('table', {
    staticClass: "ranking"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tournament.rankings[_vm.groupFilter]), function(player, rank) {
    return _c('tr', [_c('td', {
      staticClass: "rank"
    }, [_vm._v(_vm._s(rank + 1) + ".")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/profile/' + player.user_id
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.participants[player.user_id])))])])], 1), _vm._v(" "), _c('td', {
      staticClass: "points"
    }, [_vm._v(_vm._s(player.points))]), _vm._v(" "), _c('td', {
      staticClass: "games"
    }, [_vm._v(_vm._s(player.games))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "matches"
  }, _vm._l((_vm.tournament.matches), function(match) {
    return (match.group === _vm.groupFilter) ? _c('router-link', {
      key: match.id,
      staticClass: "item",
      attrs: {
        "to": '/match/' + match.id
      }
    }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm._f("name")(match.player_a)) + " vs " + _vm._s(_vm._f("name")(match.player_b)) + "\n                    ")]), _vm._v(" "), (match.status == 'completed') ? _c('div', {
      staticClass: "score"
    }, [_vm._v("\n                        " + _vm._s(match.points_a) + ":" + _vm._s(match.points_b) + "\n                    ")]) : _vm._e()]) : _vm._e()
  }))]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("Ausscheidungsphase")]), _vm._v(" "), _vm._l((_vm.tournament.matches), function(match) {
    return (match.player_a_id !== null && match.player_b_id !== null && match.group === null) ? _c('router-link', {
      key: match.id,
      staticClass: "item",
      attrs: {
        "to": '/match/' + match.id
      }
    }, [_c('h3', [_vm._v("\n                    " + _vm._s(_vm._f("name")(match.player_a)) + " vs " + _vm._s(_vm._f("name")(match.player_b)) + "\n                ")]), _vm._v(" "), _c('small', [_vm._v("\n                    " + _vm._s(_vm._f("roundName")(match.level)) + "\n                ")]), _vm._v(" "), (match.status == 'completed') ? _c('small', [_vm._v("\n                    " + _vm._s(match.points_a) + ":" + _vm._s(match.points_b) + "\n                ")]) : _vm._e()]) : _vm._e()
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.user.id == _vm.tournament.organizer_id) ? _c('section', [_c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteTournament($event)
      }
    }
  }, [_vm._v("\n            Turnier löschen\n        ")])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Spieler")]), _vm._v(" "), _c('th', [_vm._v("Punkte")]), _vm._v(" "), _c('th', [_vm._v("Sätze")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c37fee7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tournament-detail.vue
// module id = 219
// module chunks = 0